<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" center>
      <div v-for="(item, index) in dataSource" :key="index" class="hb-info-list-dialog-content">
        <span class="hb-info-list-dialog-label">{{ item.label }}： </span>
        <span class="hb-info-list-dialog-content" v-html="item.content"></span>
      </div>
      <slot></slot>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAction">好 的</el-button>
      </span>
    </el-dialog>
</template>

<script>
export default {
  name: "HBInfoListDialog",
  props: {
    dialogTitle: {
      type: String,
      default: "标题",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array,
      default: [],
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("updateVisible", val);
      },
    },
  },
  methods: {
    confirmAction() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.hb-info-list-dialog-content {
    // font-size: 18px;
    // color: #333;
    margin-bottom: 10px;
    // font-weight: 450;
    display: flex;
    flex-direction: row;
    align-content: center;
    .hb-info-list-dialog-label {
      // color: darkgrey;
      // font-weight: 400;
      min-width: 80px;
    }
    .hb-info-list-dialog-content {
      flex: 1;
      color: #333;
      font-weight: 500;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/HBCommon/HBInfoListDialog/HBInfoListDialog.vue